import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './viaturaActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Button from '../../common/form/button';

class ViaturaForm extends Component {
  render() {
    const { handleSubmit, opcoes } = this.props;
    const equipes = (opcoes && opcoes.equipes) || [];

    return (
      <form onSubmit={handleSubmit} autoComplete="off" className="simple-cad-form-premium manutencao-cad-premium viatura-cad-premium">
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-truck" /> Viatura
              </h4>
              <p>Cadastre as viaturas das equipes de manutenção.</p>
            </div>
            <div className="simple-cad-premium-body">
              <Field name="id" component={LabelAndInput} readOnly label="Código" cols="12 3" placeholder="Automático" />
              <Field name="placa" component={LabelAndInput} label="Placa" cols="12 3" placeholder="Ex.: ABC1D23" />
              <Field
                name="descricao"
                component={LabelAndInput}
                label="Descrição"
                cols="12 4"
                placeholder="Ex.: Pickup Fiat Strada"
              />
              <Field
                name="imei"
                component={LabelAndInput}
                label="IMEI (rastreador)"
                cols="12 4"
                placeholder="15 dígitos — ex.: 862667081297916"
              />
              <Field name="equipe_id" component={LabelAndSelectForm} label="Equipe" cols="12 4">
                <option value="">Sem equipe</option>
                {equipes.map(e => (
                  <option key={e.id} value={e.id}>
                    {e.nome}
                  </option>
                ))}
              </Field>
              <Field name="ativo" component={LabelAndSelectForm} label="Situação" cols="12 2">
                <option value="1">Ativa</option>
                <option value="0">Inativa</option>
              </Field>
            </div>
          </div>
        </div>
        <div className="simple-cad-premium-footer">
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

ViaturaForm = reduxForm({ form: 'viaturaForm', destroyOnUnmount: false })(ViaturaForm);
const mapStateToProps = state => ({
  opcoes: state.manutencaoViatura.opcoes,
});
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ViaturaForm);
